import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import App from './App';
import store from './redux/store';
import './i18n';
import './index.scss'
import NotificationProvider from './views/components/NotificationProvider/NotificationProvider';
import ErrorBoundary from './views/components/ErrorBoundary/ErrorBoundary';
import VersionCheck from './views/components/VersionCheck/VersionCheck';


const isInIframe = window.self !== window.top;
const isPaymentReturn = window.location.pathname.includes('/payment/success');

if (isInIframe && isPaymentReturn) {
  // The payment provider (Fondy) redirected its iframe back to us after a successful
  // payment. Booting the whole SPA here is wrong: the async auth bootstrap renders
  // RegistrationAuthPage first, which navigates the iframe to /login and then /clinic,
  // so SuccessPaymentPage never mounts. Instead, signal the parent window immediately
  // and render nothing inside the iframe.
  window.parent.postMessage('payment_success', window.location.origin);
} else {
  const domNode = document.getElementById('root');
  const root = createRoot(domNode);

  root.render(
    <BrowserRouter>
      <Provider store={store}>
        <ErrorBoundary>
          <NotificationProvider>
            <App />
            {/* Outside App on purpose: the Authorization HOC renders RegistrationAuthPage
                instead of App when there is no token, and the login screen already calls
                the API, so mounting this inside App would hide the alert from logged-out
                tabs — exactly the ones most likely to be stale. */}
            <VersionCheck />
          </NotificationProvider>
        </ErrorBoundary>
      </Provider>
    </BrowserRouter>
  );
}
